import { cn } from "@/lib/utils";
import { useContext } from "react";
import ColumnResizeHandleContext from "./ColumnResizeHandleContext";

interface ColumnResizeHandleProps {
  onMouseDown: (event: React.MouseEvent<HTMLDivElement>) => void;
  onTouchStart: (event: React.TouchEvent<HTMLDivElement>) => void;
  columnId: string;
}

export default function ColumnResizeHandle(props: ColumnResizeHandleProps) {
  const { resizedColumnId, startResize } = useContext(
    ColumnResizeHandleContext,
  );

  const onResizeStart = (
    event: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>,
  ) => {
    event.stopPropagation();
    event.preventDefault();
    startResize(props.columnId);
  };

  const onMouseDown = (event: React.MouseEvent<HTMLDivElement>) => {
    onResizeStart(event);
    props.onMouseDown(event);
  };

  const onTouchStart = (event: React.TouchEvent<HTMLDivElement>) => {
    onResizeStart(event);
    props.onTouchStart(event);
  };

  const isDragging = resizedColumnId === props.columnId;

  return (
    <div
      onMouseDown={onMouseDown}
      onTouchStart={onTouchStart}
      className={cn(
        "w-5 h-full opacity-0 hover:opacity-100 absolute z-10 right-[-9px] top-0 cursor-col-resize flex items-center justify-center",
        isDragging && "opacity-100",
      )}
    >
      <div
        className={cn("w-1 h-full bg-blue-400/50", isDragging && "bg-blue-400")}
      />
    </div>
  );
}
